import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { cn } from '../../../utils/cn';
import { ToastProps } from './Toast.types';

const toastIcons = {
  success: CheckCircle,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
};

const toastColors = {
  success: 'bg-green-50 dark:bg-green-900/30 border-green-500 text-green-900 dark:text-green-100',
  error: 'bg-red-50 dark:bg-red-900/30 border-red-500 text-red-900 dark:text-red-100',
  warning:
    'bg-yellow-50 dark:bg-yellow-900/30 border-yellow-500 text-yellow-900 dark:text-yellow-100',
  info: 'bg-blue-50 dark:bg-blue-900/30 border-blue-500 text-blue-900 dark:text-blue-100',
};

const toastIconColors = {
  success: 'text-green-500 dark:text-green-400',
  error: 'text-red-500 dark:text-red-400',
  warning: 'text-yellow-500 dark:text-yellow-400',
  info: 'text-blue-500 dark:text-blue-400',
};

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  const Icon = toastIcons[toast.type];

  return (
    <div
      className={cn(
        'pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-lg border-l-4 p-4 shadow-lg dark:shadow-slate-900/50',
        toastColors[toast.type]
      )}
      role="alert"
      aria-live="polite"
    >
      {/* Icon */}
      <Icon
        className={cn('h-5 w-5 flex-shrink-0', toastIconColors[toast.type])}
        aria-hidden="true"
      />

      {/* Content */}
      <div className="flex-1">
        {toast.title && <p className="font-semibold">{toast.title}</p>}
        <p className={cn(!toast.title && 'font-medium')}>{toast.message}</p>
      </div>

      {/* Close Button */}
      <button
        onClick={() => onClose(toast.id)}
        className="flex-shrink-0 rounded p-1 transition-colors hover:bg-black/5 dark:hover:bg-white/10"
        aria-label="Close notification"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
